<template>
  <div>
    <b-form-input v-model="textFilter"
                  type="text"
                  class="mb-2"
                  placeholder="Busca por tienda o cadena"></b-form-input>

    <Loader v-if="loading"></Loader>
    <b-list-group v-else class="border-0">
      <b-list-group-item list-group-item-action class="pointer" v-for="list in filteredData" :key="list.store_id"
                         @click="goToStore(list.store_id)">
        <h6>{{list.retail_name}}</h6>
        <strong>{{list.retail_store_name}}</strong>
      </b-list-group-item>
    </b-list-group>


  </div>

</template>

<script>
  import Loader from '@/expertoRetail/atoms/ExpertoRetailLoader'
  import { storeListParameters } from '../../expertoRetail/defaultPayloads/organismsMobile'
  import { sales } from '../../services/api/ExpertoRetail'

  export default {
    name: 'mobile-store-list',
    props: {
      // data: {
      //   type: Array,
      //   required: true,
      //   default: 0
      // }
    },
    components: {
      Loader
    },
    data () {
      return {
        storeList: {
          data: {}
        },
        textFilter: '',
        // selected: 'retail_store_name',
        loading: false
      }
    },
    created () {
      this.storeListRequest(storeListParameters)
    },
    methods: {
      goToStore (id) {
        // this.$router.push({name: 'StoreDetail', params: {store_id: id}})
        this.$router.push({name: 'StoreDetail'})
        this.$store.commit('commit_store_id', id) // centraliza el store_id en vuex
      },
      storeListRequest (parameters) {
        this.loading = true
        return new Promise((resolve, reject) => {
          let vm = this
          sales.salesTwoRanges(parameters)
            .then(response => {
              this.storeList.data = response.data
              resolve()
            })
            .catch(error => {
              reject(error)
            })
            .finally(() => {
              vm.loading = false
            })
        })
      }
    },
    computed: {
      filteredData () {
        // If there is no filter text, just return everyone
        if (!this.textFilter) return this.storeList.data

        // Convert the search text to lower case
        let searchText = this.textFilter.toLowerCase()
        return this.storeList.data.filter(p => {
          return p.retail_store_name.toLowerCase().includes(searchText) ||
            p.retail_name.toLowerCase().includes(searchText)
        })
      }
    }
  }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/expertoRetail/atoms/ExpertoRetailMobileStoreList.vue